import { GET_SHOP_DRAFT_PRODUCTS } from "../constants/endpoints";
import axiosClient from "./axios";

class shopDraftProductService {
  static async fetchShopDraftProduct(
    shopId: any,
    currentPage: number,
    itemsPerPage: number,
    productName: string | null = null,
    subCategory: string | null = null,
    brand: string | null = null,
    maxImagesCount: number | null = null,
    isActive: boolean | null = null,
    emptyImagesArray: boolean | null = null,
    barcode: string | null = null,
    isOldStock: boolean | null = null,
    isOutOfStock: boolean | null = null,
    dataSource: string | null = null,
    created_at: string | null = null,
    modified_at: string | null = null,
    domain: string | null = null
  ) {
    const url = GET_SHOP_DRAFT_PRODUCTS.replace("{shopId}", shopId);
    const filters = {
      productName: productName !== null ? productName : undefined,
      subCategory: subCategory !== null ? subCategory : undefined,
      brand: brand !== null ? brand : undefined,
      maxImagesCount: maxImagesCount !== null ? maxImagesCount : undefined,
      isActive: isActive !== null ? isActive : undefined,
      emptyImagesArray:
        emptyImagesArray !== null ? emptyImagesArray : undefined,
      barcode: barcode !== null ? barcode : undefined,
      isOldStock: isOldStock !== null ? isOldStock : undefined,
      isOutOfStock: isOutOfStock !== null ? isOutOfStock : undefined,
      dataSource: dataSource !== null ? dataSource : undefined,
      domain: domain !== null ? domain : undefined,
    };
    const sort = {
      created_at: created_at !== null ? created_at : undefined,
      modified_at: modified_at !== null ? modified_at : undefined,
    };
    const response = await axiosClient.post(url, {
      page: currentPage,
      limit: itemsPerPage,
      filters: filters,
      sort: sort,
    });
    return response;
  }
}

export default shopDraftProductService;
